/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxButtonModule } from 'devextreme-angular';
import { ManageModeSrcPanelFrameModule } from '../manage-mode-src-panel-frame';
import { ManageModeDestPanelFrameModule } from '../manage-mode-dest-panel-frame';
import { ManageModeComponent } from './manage-mode.component';
import { AlertModule } from '../../../../../../shared/ui/src/lib/components/alert';

@NgModule({
  declarations: [
    ManageModeComponent
  ],
  imports: [
    CommonModule,
    ManageModeSrcPanelFrameModule,
    ManageModeDestPanelFrameModule,
    AlertModule,
    DxButtonModule
  ],
  exports: [
    ManageModeComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ManageModeModule { }